// config.ts
import { Tokens } from "./Tokens";

// Initialize tokens
const tokens = Tokens.getInstance();

export { tokens };